import Dialog from '@anm/components/modals/Dialog';
import { ModalProps } from '@anm/components/modals/Modal';
import { FC } from 'react';

import Wrapper, {
  ButtonsContainer,
  ButtonContainer,
  ButtonHint,
  IconButtonWrapper,
  InfoContainer,
  ShareButtonWrapper,
  Title
} from './Wrapper';

type UploadSuccessModalMobileProps = ModalProps & {
  landingTabUrl: string;
  onShare(): void;
};

const UploadSuccessModalMobile: FC<UploadSuccessModalMobileProps> = ({ landingTabUrl, onShare, onModalClose }) => (
  <Dialog {...{ onModalClose }} onSubmit={onShare}>
    <Wrapper>
      <InfoContainer>
        <Title
          title="Your video looks great!"
          description="The mobile version of Wave.video allows you to upload and share videos on the go. To edit your video, <b>please sign in on desktop.</b>"
        />
      </InfoContainer>
      <ButtonsContainer>
        <ButtonContainer>
          <ButtonHint maxWidth={215}>Give your video a landing page with text and a CTA</ButtonHint>
          <IconButtonWrapper
            size="large"
            href={landingTabUrl}
            buttonType="container"
            variant="white-blue-border-share"
            icon="images/icons/landing_grey_icon.svg"
          >
            Make a landing page
          </IconButtonWrapper>
        </ButtonContainer>
        <ButtonContainer>
          <ButtonHint maxWidth={130}>Share the link to your video</ButtonHint>
          <ShareButtonWrapper
            size="large"
            iconSize="small"
            icon="images/dashboard/share-blue.svg"
            variant="white-blue-border-share"
            onClick={onShare}
          >
            Share
          </ShareButtonWrapper>
        </ButtonContainer>
      </ButtonsContainer>
    </Wrapper>
  </Dialog>
);

export default UploadSuccessModalMobile;
